import _regeneratorRuntime from 'babel-runtime/regenerator';
import _Promise from 'babel-runtime/core-js/promise';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import Uploader from '@/components/Uploader/index.vue';
import { readFileAsDataURL } from '@/utils/fileReader.js';
import CropperDialog from '@pt/components/cropper-dialog/index.vue';
import { uploadFile } from '@/api/common/upload';

export default {
  props: {
    uploading: Boolean,
    uploader: Object,
    metaData: Object
  },

  components: {
    Uploader: Uploader,
    CropperDialog: CropperDialog
  },

  data: function data() {
    return {
      fileList: [],
      visible: false,
      cropper: {}
    };
  },


  computed: {
    uploadButton: function uploadButton() {
      return {
        size: 'small',
        type: 'primary',
        loading: this.uploading
      };
    },
    innerUploader: function innerUploader() {
      var data = {};
      return _extends({
        data: data,
        beforeUpload: this.beforeUpload,
        multiple: false,
        drag: true
      }, this.uploader);
    }
  },

  methods: {
    uploadFile: uploadFile,

    updateUploading: function updateUploading(val) {
      this.$emit('update:uploading', val);
    },
    handleUploadSuccess: function handleUploadSuccess(_ref) {
      var file = _ref.file;

      this.$emit('upload-success', { file: file });
    },
    beforeUpload: function beforeUpload(file) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result, dataURL, fileTypeParts;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return readFileAsDataURL(file);

              case 3:
                result = _context.sent;
                dataURL = result.target.result;
                fileTypeParts = file.type.split('/');

                _this.cropper = {
                  img: dataURL,
                  outputType: fileTypeParts[fileTypeParts.length - 1]
                };
                if (_this.metaData) {
                  _this.cropper = _extends({}, _this.cropper, {
                    autoCropWidth: _this.metaData.width,
                    autoCropHeight: _this.metaData.height
                  });
                }
                _this.visible = true;
                _this.updateUploading(false);
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);
                _this.$message.error(_this.$t('playTurbo.creative.localResourceInZipDialog.imageUploader.error'));

              case 16:
                return _context.abrupt('return', _Promise.reject());

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 12]]);
      }))();
    },
    onChange: function onChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    }
  }
};